module.exports = __webpack_public_path__ + "static/wytwornia-papierow-wartosciowych-c191e2d8b26bfa061cc1e31251da3b80.jpg";